import { Component } from '@angular/core';
import {  OnInit } from '@angular/core';

import { HttpClient } from '@angular/common/http';
@Component({
  selector: 'app',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
  providers : [] 
})
export class HomeComponent {
  data : Object;
  name : String;
  constructor(public http: HttpClient){
    
  }

  ngOnInit(): void {
    this.http.get('./assets/configs/home.json').subscribe(data => {
       this.data = data;
       this.name = data[0].name;
    });
  }
}




// WEBPACK FOOTER //
// /Users/haydenso/Desktop/Code/Projects/haydensookchand/website_source/src/app/home/home.component.ts